import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { toast } from "react-toastify";
import { withRouter, Link } from "react-router-dom";
import TableContainer from "./TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
  UncontrolledDropdown,
  DropdownToggle,
  Tooltip,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";

// import { DefaultColumnFilter } from './filters';


import { Name, Email, Tags, Projects, Img } from "./contactlistCol";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "./DeleteModal";

import {
  getUsers as onGetUsers,
  addNewUser as onAddNewUser,
  updateUser as onUpdateUser,
  deleteUser as onDeleteUser,
  resetCreateUserState,
  resetUpdateUserState,
  resetDeleteUserState,
} from "store/contacts/actions";
import { isEmpty } from "lodash";
import { DefaultColumnFilter } from './filters';

//redux
import { useSelector, useDispatch } from "react-redux";
import ModalAddUser from "./ModalAddUser";
import ModalEditUser from "./ModalEditUser";
import LoadingSpinnerSmall from "components/Common/LoadingSpinner/LoadingSpinnerSmall";
import LoadingSpinnerSmaller from "components/Common/LoadingSpinner/LoadingSpinnerSmaller";

// Fora do componente ContactsList
// const DefaultColumnFilter = React.memo(function DefaultColumnFilter({ column: { filterValue, preFilteredRows, setFilter, id } }) {
//   const count = preFilteredRows.length;
//   // console.log("filterValue", filterValue);
//   return (
//     <input
//       id={`filter-${id}`}
//       name={`filter-${id}`}
//       value={filterValue || ""}
//       onChange={e => {
//         setFilter(e.target.value || undefined);
//       }}
//       placeholder={`Buscar em ${count} registros...`}
//     />
//   );
// });


const ContactsList = props => {

  //meta title
  document.title = "Lista de Usuários | Skote - React Admin & Dashboard Template";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [loadingTable, setLoadingTable] = useState(false);
  const [filters, setFilters] = useState({});
  const [startPanel, setStartPanel] = useState(true);
  const [pageSize, setPageSize] = useState(10);
  const [tooltipOpen, setTooltipOpen] = useState(false)
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: (contact && contact.name) || "",
      designation: (contact && contact.designation) || "",
      tags: (contact && contact.tags) || "",
      email: (contact && contact.email) || "",
      projects: (contact && contact.projects) || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Your Name"),
      designation: Yup.string().required("Please Enter Your Designation"),
      tags: Yup.array().required("Please Enter Tag"),
      email: Yup.string().required("Please Enter Your Email"),
      projects: Yup.number().required("Please Enter Your Project"),
    }),
    onSubmit: values => {
      if (isEdit) {
        const updateUser = {
          id: contact.id,
          name: values.name,
          designation: values.designation,
          tags: values.tags,
          email: values.email,
          projects: values.projects,
        };

        // update user
        dispatch(onUpdateUser(updateUser));
        validation.resetForm();
        setIsEdit(false);
      } else {
        const newUser = {
          id: Math.floor(Math.random() * (30 - 20)) + 20,
          name: values["name"],
          designation: values["designation"],
          email: values["email"],
          tags: values["tags"],
          projects: values["projects"],
        };
        // save new user
        dispatch(onAddNewUser(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });
  const [loadingRefreshTable, setLoadingRefreshTable] = useState(false)
  const { users, getUsersError } = useSelector(state => ({
    users: state.contacts ? state.contacts.users : [],
    getUsersError: state.contacts ? state.contacts.error : null,
  }));

  const loggedUserId = JSON.parse(window.sessionStorage.getItem("authUser") || "{}")?.id

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [modalDeleteError, setModalDeleteError] = useState(false)
  const [createUserLoading, setCreateUserLoading] = useState(false)
  const [modalCreateUserError, setModalCreateUserError] = useState(null)
  const [editUserLoading, setEditUserLoading] = useState(false)
  const [modalEditUserError, setModalEditUserError] = useState(null)
  const [userEditId, setUserEditId] = useState("")

  const toggle = useCallback(() => {
    setModal(prevModal => !prevModal);
  }, []);


  const onClickDelete = useCallback((users) => {
    dispatch(resetDeleteUserState());
    setContact(users);
    setModalDeleteError(false)
    setDeleteLoading(false)
    setDeleteModal(true);
  }, []);

  const handleUserClick = useCallback(
    (arg) => {
      const user = arg;
      console.log("dentro do handleUserClick")
      setContact({
        id: user.id,
        name: user.name,
        designation: user.designation,
        email: user.email,
        tags: user.tags,
        projects: user.projects,
      });
      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  //   // Definição do filtro de coluna padrão
  // const DefaultColumnFilter = React.memo(function DefaultColumnFilter({ column: { filterValue, preFilteredRows, setFilter, id } }) {
  //   const count = preFilteredRows.length;
  //   console.log("filterValue", filterValue);
  //   return (
  //     <input
  //       id={`filter-${id}`}
  //       name={`filter-${id}`}
  //       value={filterValue || ""}
  //       onChange={e => {
  //         setFilter(e.target.value || undefined);
  //       }}
  //       placeholder={`Buscar em ${count} registros...`}
  //     />
  //   );
  // });
  const columns = useMemo(() => [
    {
      Header: 'Nome',
      accessor: 'Name',
      filterable: true,
      Filter: DefaultColumnFilter,
      Cell: ({ value, row }) => (
        <span>
          {value}
          {row.original.Id === loggedUserId && (
            <span className="badge bg-primary ms-2" style={{ fontSize: "0.65rem" }}>Você</span>
          )}
        </span>
      ),
    },
    {
      Header: 'E-mail',
      accessor: 'Email',
      filterable: true,
      Filter: DefaultColumnFilter,
      Cell: ({ value }) => <span>{value}</span>,
    },
    {
      Header: 'Perfil',
      accessor: 'Perfil',
      disableFilters: true,
      Cell: ({ value, row }) => {
        const PERFIL_LABELS = { super_admin: "Super Admin", admin: "Admin", analista: "Analista", cliente: "Cliente" }
        return (
          <div>
            <span>{PERFIL_LABELS[value] || value}</span>
            {row.original.Parceiro?.Nome && (
              <div className="text-muted" style={{ fontSize: "0.75rem" }}>
                {row.original.Parceiro.Nome}
              </div>
            )}
          </div>
        )
      },
    },
    {
      Header: 'Status',
      id: 'Status',
      accessor: row => row.Status === 1 ? 'Ativo' : 'Inativo',
      disableFilters: true,
      Cell: ({ value }) => (
        <span className={`badge ${value === 'Ativo' ? 'bg-success' : 'bg-danger'}`}>
          {value}
        </span>
      ),
    },
    {
      Header: 'Ação',
      Cell: cellProps => {
        const userData = cellProps.row.original
        const isSelf = userData.Id === loggedUserId
        return (
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-success"
              onClick={() => { if (!isSelf) toggleModalEditUserCallCode(userData) }}
              style={isSelf ? { opacity: 0.35, cursor: "not-allowed", pointerEvents: "none" } : {}}
              id={`editbtn-${userData.Id}`}
            >
              <i className="mdi mdi-pencil font-size-18" />
            </Link>
            {isSelf && (
              <UncontrolledTooltip placement="top" target={`editbtn-${userData.Id}`}>
                Use a página de Perfil para editar seus dados
              </UncontrolledTooltip>
            )}
            {!isSelf && (
              <UncontrolledTooltip placement="top" target={`editbtn-${userData.Id}`}>
                Editar
              </UncontrolledTooltip>
            )}
            <Link
              to="#"
              className={userData.Status === 1 ? "text-danger" : "text-success"}
              onClick={() => { if (!isSelf) onClickDelete(userData) }}
              style={isSelf ? { opacity: 0.35, cursor: "not-allowed", pointerEvents: "none" } : {}}
              id={`toggletooltip-${userData.Id}`}
            >
              <i className={`mdi ${userData.Status === 1 ? "mdi-account-cancel" : "mdi-account-check"} font-size-18`} />
            </Link>
            {isSelf && (
              <UncontrolledTooltip placement="top" target={`toggletooltip-${userData.Id}`}>
                Não é possível alterar seu próprio status
              </UncontrolledTooltip>
            )}
            {!isSelf && (
              <UncontrolledTooltip placement="top" target={`toggletooltip-${userData.Id}`}>
                {userData.Status === 1 ? "Inativar" : "Ativar"}
              </UncontrolledTooltip>
            )}
          </div>
        )
      },
    },
  ], [handleUserClick, onClickDelete]);

  useEffect(() => {
    setLoadingTable(true)
    dispatch(onGetUsers());
    setIsEdit(false);
  }, [dispatch]);

  useEffect(() => {
    setContact(users);
    setIsEdit(false);
    setLoadingTable(false)
    setLoadingRefreshTable(false)
  }, [users]);

  useEffect(() => {
    if (getUsersError) {
      setLoadingTable(false)
      setLoadingRefreshTable(false)
    }
  }, [getUsersError]);

  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users);
      setIsEdit(false);
    }
  }, [users]);




  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);


  const { deleteSuccess, deleteError, createUserSuccess, createUserError, updateUserSuccess, updateUserError } = useSelector(state => ({
    deleteSuccess: state.contacts.deleteSuccess,
    deleteError: state.contacts.deleteError,
    createUserSuccess: state.contacts.createUserSuccess,
    createUserError: state.contacts.createUserError,
    updateUserSuccess: state.contacts.updateUserSuccess,
    updateUserError: state.contacts.updateUserError,
  }));
  useEffect(() => {
    if (deleteSuccess) {
      toast.success(contact?.Status === 1 ? "Usuário inativado com sucesso." : "Usuário reativado com sucesso.")
      setDeleteModal(false);
      onPaginationPageChange(1);
      dispatch(onGetUsers());
      setDeleteLoading(false)
    }
  }, [deleteSuccess]);

  useEffect(() => {
    if (deleteError) {
      // Exibir um alerta ou mensagem de erro em caso de falha
      console.error("Erro ao deletar usuário:", deleteError);
      setModalDeleteError(true)
      dispatch(onGetUsers());
      setDeleteLoading(false)
    }
  }, [deleteError]);



  useEffect(() => {
    if (createUserSuccess) {
      toast.success("Usuário cadastrado com sucesso.")
      setShowModal(false);
      onPaginationPageChange(1);
      dispatch(onGetUsers());
      setCreateUserLoading(false)
    }
  }, [createUserSuccess]);

  useEffect(() => {
    if (createUserError) {
      // Exibir um alerta ou mensagem de erro em caso de falha
      console.error("Erro ao criar usuário:", createUserError);
      const msg = createUserError?.response?.data?.message || "Erro ao cadastrar usuário."
      setModalCreateUserError(msg)
      dispatch(onGetUsers());
      setCreateUserLoading(false)
    }
  }, [createUserError]);




  useEffect(() => {
    if (updateUserSuccess) {
      toast.success("Usuário atualizado com sucesso.")
      setShowModalEditUser(false);
      onPaginationPageChange(1);
      dispatch(onGetUsers());
      setEditUserLoading(false)
    }
  }, [updateUserSuccess]);

  useEffect(() => {
    if (updateUserError) {
      // Exibir um alerta ou mensagem de erro em caso de falha
      console.error("Erro ao atualizar usuário:", updateUserError);
      const msg = updateUserError?.response?.data?.message || "Erro ao atualizar dados do usuário."
      setModalEditUserError(msg)
      dispatch(onGetUsers());
      setEditUserLoading(false)
    }
  }, [updateUserError]);








  const handleDeleteUser = () => {
    console.log("CONTACT HANDLE DELETE USER", contact);
    setDeleteLoading(true)
    dispatch(onDeleteUser(contact));

    setTimeout(() => {
      if(deleteLoading === true){
        setDeleteLoading(false)
      }
    }, 60000)
  };


  const handleUserClicks = useCallback(() => {
    setUserList("");
    setIsEdit(false);
    toggle();
  }, [toggle]);

  const handleQualificacaoClick = () => {
    // Implement this function based on your needs
  };

  const keyField = "id";

  useEffect(() => {
    if (users.length > 0) {
      console.log("users", users)

    }
  }, [users])


  const toggleModal = () => {
    dispatch(resetCreateUserState());
    setModalCreateUserError(null)
    setInputs([{ nome: "", email: "", senha: "", perfil: "", parceiroId: "" }])
    setIsValidInputs([{ nome: false, email: false, senha: false, perfil: false, parceiroId: true }])
    setShowModal(!showModal)
   }
  const toggleModalEditUserCallCode = (userData) => {
    dispatch(resetUpdateUserState());
    setModalEditUserError(null)
    setInputsEditUser([{ nome: userData?.Name || "", email: userData?.Email || "", senha: "", perfil: userData?.Perfil || "", parceiroId: userData?.ParceiroId || "" }])
    setIsValidInputsEditUser([{ nome: !!userData?.Name, email: !!userData?.Email, senha: true, perfil: !!userData?.Perfil, parceiroId: true }])
    setUserEditId(userData?.Id)
    setShowModalEditUser(!showModalEditUser)
   }


  const handleRefreshTable = () => {
    setLoadingRefreshTable(true)
    setLoadingTable(true)
    dispatch(onGetUsers());
  }


  const [showModal, setShowModal] = useState(false);
  const [showModalEditUser, setShowModalEditUser] = useState(false);
  const [inputs, setInputs] = useState([
    { nome: '', email: '', senha: '', perfil: '', parceiroId: '' },
  ]);
  const [isValidInputs, setIsValidInputs] = useState([
    { nome: false, email: false, senha: false, perfil: false, parceiroId: true },
  ]);
  const [inputsEditUser, setInputsEditUser] = useState([
    { nome: '', email: '', senha: '', perfil: '', parceiroId: '' },
  ]);
  const [isValidInputsEditUser, setIsValidInputsEditUser] = useState([
    { nome: false, email: false, senha: true, perfil: false, parceiroId: true },
  ]);


  const toggleModalAddUser = () => setShowModal(!showModal);
  const toggleModalEditUser = () => setShowModalEditUser(!showModalEditUser);

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
        loading={deleteLoading}
        error={modalDeleteError}
        userStatus={contact?.Status}
      />
      <ModalAddUser
        toggleModal={toggleModalAddUser}
        showModal={showModal}
        setShowModal={setShowModal}
        inputs={inputs}
        setInputs={setInputs}
        isValidInputs={isValidInputs}
        setIsValidInputs={setIsValidInputs}
        setLoading={setCreateUserLoading}
        loading={createUserLoading}
        error={modalCreateUserError}
      />
      <ModalEditUser
        toggleModal={toggleModalEditUser}
        showModal={showModalEditUser}
        setShowModal={setShowModalEditUser}
        inputs={inputsEditUser}
        setInputs={setInputsEditUser}
        isValidInputs={isValidInputsEditUser}
        setIsValidInputs={setIsValidInputsEditUser}
        setLoading={setEditUserLoading}
        loading={editUserLoading}
        error={modalEditUserError}
        userId={userEditId}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Contacts" breadcrumbItem="Lista de Usuários" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5 className="mb-0 card-title flex-grow-1">
                      Lista de Usuários
                    </h5>
                    <div className="d-flex align-items-center">
                      <button
                        id="addProcessButton"
                        className="btn btn-primary me-1"
                        onClick={toggleModal}
                      >
                        <i className="mdi mdi-plus"></i>
                      </button>
                      <Tooltip
                        target="addProcessButton"
                        placement={"bottom"}
                        isOpen={tooltipOpen}
                        toggle={() => setTooltipOpen(!tooltipOpen)}
                      >
                        Adicionar usuário
                      </Tooltip>

                      <button onClick={handleRefreshTable} className="btn btn-light me-1">
                        {!loadingRefreshTable ? <i className="mdi mdi-refresh"></i> : <LoadingSpinnerSmaller/>}
                        
                        
                      </button>
                      {/* <UncontrolledDropdown className="dropdown d-inline-block me-1">
                        <DropdownToggle
                          type="menu"
                          className="btn btn-success"
                          id="dropdownMenuButton1"
                        >
                          <i className="mdi mdi-dots-vertical"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                          <li>
                            <DropdownItem
                              onClick={() => setEditLoteModal(true)}
                            >
                              Editar em lote
                            </DropdownItem>
                          </li>
                          <li>
                            <DropdownItem onClick={() => setCargaModal(true)}>
                              Carga em lote
                            </DropdownItem>
                          </li>
                        </DropdownMenu>
                      </UncontrolledDropdown> */}
                    </div>
                  </div>
                </CardBody>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={users}
                    isGlobalFilter={true}
                    isAddUserList={true}
                    handleUserClick={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                    setLoading={setLoadingTable}
                    loading={loadingTable}
                    selectedFilters={filters}
                    setFilters={setFilters}
                    startPanel={startPanel}
                    setStartPanel={setStartPanel}
                    setPageSizeClick={setPageSize}
                  />

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Edit User" : "Add User"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row form>
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label className="form-label">Name</Label>
                              <Input
                                name="name"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.name || ""}
                                invalid={
                                  validation.touched.name &&
                                    validation.errors.name
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.name &&
                                validation.errors.name ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.name}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="form-label">Designation</Label>
                              <Input
                                name="designation"
                                label="Designation"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.designation || ""}
                                invalid={
                                  validation.touched.designation &&
                                    validation.errors.designation
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.designation &&
                                validation.errors.designation ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.designation}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="form-label">Email</Label>
                              <Input
                                name="email"
                                label="Email"
                                type="email"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.email || ""}
                                invalid={
                                  validation.touched.email &&
                                    validation.errors.email
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.email &&
                                validation.errors.email ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.email}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="form-label">Option</Label>
                              <Input
                                type="select"
                                name="tags"
                                className="form-select"
                                multiple={true}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.tags || []}
                                invalid={
                                  validation.touched.tags &&
                                    validation.errors.tags
                                    ? true
                                    : false
                                }
                              >
                                <option>Photoshop</option>
                                <option>illustrator</option>
                                <option>Html</option>
                                <option>Php</option>
                                <option>Java</option>
                                <option>Python</option>
                                <option>UI/UX Designer</option>
                                <option>Ruby</option>
                                <option>Css</option>
                              </Input>
                              {validation.touched.tags &&
                                validation.errors.tags ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.tags}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="form-label">Projects</Label>
                              <Input
                                name="projects"
                                label="Projects"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.projects || ""}
                                invalid={
                                  validation.touched.projects &&
                                    validation.errors.projects
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.projects &&
                                validation.errors.projects ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.projects}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Save
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
